import * as Yup from 'yup';
import { SarlaftForm } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftForm = {
    numberForm: '',
};

export const validationSchema = Yup.object({
    numberForm: Yup.string().required('El número de fomulario es obligatorio'),
});
